import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import type { ComponentProps } from 'react';
import { LogoFull } from '../nav/LogoFull';
import './signin.css';

/**
 * Branded sign-in splash. The stock SignInPage (same component the default
 * app extension uses, so the guest auth flow is byte-for-byte identical) is
 * mounted inside the white panel and restyled by signin.css; everything
 * around it is the brand composition described there.
 */
const CleverSignInPage = (props: object) => (
  <div className="clever-splash">
    <main className="clever-splash-panel">
      <div className="clever-splash-logo">
        <LogoFull />
      </div>
      <div className="clever-splash-rule" aria-hidden="true" />
      <h1 className="clever-splash-title">Application Portfolio Management</h1>
      <div className="clever-splash-signin">
        <SignInPage
          {...(props as ComponentProps<typeof SignInPage>)}
          providers={['guest']}
        />
      </div>
    </main>
    <p className="clever-splash-foot">CLEVER PLATFORM&ensp;&middot;&ensp;JEDDAH, KSA</p>
  </div>
);

const cleverSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => <CleverSignInPage {...props} />,
  },
});

export const signInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [cleverSignInPage],
});
